/**
 * Recovery Cream PDP - Proof Helpers (Read-Only Diagnostics)
 * Loaded only when .recovery-cream-hero__container exists
 * NO side effects - diagnostic only
 */
(function() {
  'use strict';
  
  // PHASE A: Runtime Sticky Proof Function (computed-style + scroll test)
  window.rcStickyProof = function() {
    console.log('=== RECOVERY CREAM STICKY RUNTIME PROOF ===\n');
    
    var reasons = [];
    var width = window.innerWidth;
    var isDesktop = width >= 769;
    
    console.log('1. Environment:');
    console.log('   Window width:', width, isDesktop ? '(Desktop ✅)' : '(Mobile ❌)');
    console.log('   URL:', window.location.pathname);
    console.log('');
    
    // Find grid container
    var container = document.querySelector('.recovery-cream-hero__container');
    if (!container) {
      reasons.push('Grid container not found');
      console.log('❌ FAIL: Grid container (.recovery-cream-hero__container) not found');
      return { pass: false, reasons: reasons, stickyTop: 0, actualTop: 0, htmlOverflowY: '', bodyOverflowY: '' };
    }
    
    var containerComputed = getComputedStyle(container);
    var containerDisplay = containerComputed.display;
    var isGrid = containerDisplay === 'grid' || containerDisplay.includes('grid');
    
    console.log('2. Grid Container Analysis:');
    console.log('   Selector: .recovery-cream-hero__container');
    console.log('   Display:', containerDisplay, isGrid ? '(Grid ✅)' : '(Not Grid ❌)');
    console.log('   Grid template columns:', containerComputed.gridTemplateColumns);
    console.log('   Grid template areas:', containerComputed.gridTemplateAreas);
    console.log('   Align items:', containerComputed.alignItems);
    console.log('');
    
    if (!isGrid && isDesktop) {
      reasons.push('Container is not grid at desktop width');
    }
    
    // List direct children
    var directChildren = Array.from(container.children);
    console.log('3. Direct Grid Children (' + directChildren.length + '):');
    directChildren.forEach(function(child, i) {
      var childComputed = getComputedStyle(child);
      var selector = child.className ? '.' + child.className.split(' ').join('.') : child.tagName.toLowerCase();
      console.log('   ' + (i + 1) + '. ' + selector);
      console.log('      Grid area:', childComputed.gridArea || 'none');
      console.log('      Display:', childComputed.display);
    });
    console.log('');
    
    // Find sticky element
    var stickyEl = document.querySelector('.recovery-cream-hero__images');
    if (!stickyEl) {
      reasons.push('Sticky element not found');
      console.log('❌ FAIL: Sticky element (.recovery-cream-hero__images) not found');
      return { pass: false, reasons: reasons, stickyTop: 0, actualTop: 0, htmlOverflowY: '', bodyOverflowY: '' };
    }
    
    var isDirectChild = directChildren.includes(stickyEl);
    console.log('4. Sticky Element:');
    console.log('   Selector: .recovery-cream-hero__images');
    console.log('   Is direct grid child:', isDirectChild ? '✅ YES' : '❌ NO');
    if (!isDirectChild) {
      reasons.push('Sticky element is not direct child of grid container');
    }
    console.log('');
    
    // Sticky element computed styles
    var stickyComputed = getComputedStyle(stickyEl);
    console.log('5. Sticky Element Computed Styles:');
    console.log('   position:', stickyComputed.position);
    console.log('   top:', stickyComputed.top);
    console.log('   height:', stickyComputed.height);
    console.log('   max-height:', stickyComputed.maxHeight);
    console.log('   align-self:', stickyComputed.alignSelf);
    console.log('   grid-area:', stickyComputed.gridArea);
    console.log('   overflow:', stickyComputed.overflow);
    console.log('   overflow-y:', stickyComputed.overflowY);
    console.log('');
    
    if (stickyComputed.position !== 'sticky') {
      reasons.push('Position is not sticky: ' + stickyComputed.position);
    }
    if (stickyComputed.top === 'auto' || stickyComputed.top === '') {
      reasons.push('Top is auto or empty: ' + stickyComputed.top);
    }
    
    // Ancestor chain analysis
    console.log('6. Ancestor Chain (sticky → html) with ALL Properties:');
    var ancestors = [];
    var current = stickyEl.parentElement;
    var level = 0;
    
    while (current && current !== document.body && level < 20) {
      ancestors.push(current);
      current = current.parentElement;
      level++;
    }
    ancestors.push(document.body);
    ancestors.push(document.documentElement);
    
    var ancestorBreakers = [];
    ancestors.forEach(function(ancestor, i) {
      var ancComputed = getComputedStyle(ancestor);
      var tag = ancestor.tagName.toLowerCase();
      var selector = tag;
      if (ancestor.className) {
        selector += '.' + ancestor.className.split(' ').filter(Boolean).join('.');
      }
      if (ancestor.id) {
        selector += '#' + ancestor.id;
      }
      
      var props = {
        position: ancComputed.position,
        top: ancComputed.top,
        overflow: ancComputed.overflow,
        overflowX: ancComputed.overflowX,
        overflowY: ancComputed.overflowY,
        transform: ancComputed.transform,
        filter: ancComputed.filter,
        backdropFilter: ancComputed.backdropFilter,
        perspective: ancComputed.perspective,
        contain: ancComputed.contain,
        willChange: ancComputed.willChange
      };
      
      console.log('   ' + (i + 1) + '. ' + selector + ':');
      console.log('      position:', props.position);
      console.log('      overflow:', props.overflow, '/ overflow-x:', props.overflowX, '/ overflow-y:', props.overflowY);
      console.log('      transform:', props.transform === 'none' ? 'none' : props.transform.substring(0, 50));
      console.log('      filter:', props.filter === 'none' ? 'none' : props.filter);
      console.log('      backdrop-filter:', props.backdropFilter === 'none' ? 'none' : props.backdropFilter);
      console.log('      perspective:', props.perspective === 'none' ? 'none' : props.perspective);
      console.log('      contain:', props.contain || 'none');
      console.log('      will-change:', props.willChange || 'auto');
      
      // Check for breakers
      var isBreaker = false;
      var breakerReasons = [];
      
      if (props.overflowY === 'hidden' || props.overflowY === 'scroll' || props.overflowY === 'auto' || props.overflowY === 'clip') {
        isBreaker = true;
        breakerReasons.push('overflow-y=' + props.overflowY);
      }
      if (props.transform !== 'none' && props.transform !== 'matrix(1, 0, 0, 1, 0, 0)') {
        isBreaker = true;
        breakerReasons.push('transform=' + props.transform.substring(0, 30));
      }
      if (props.filter !== 'none') {
        isBreaker = true;
        breakerReasons.push('filter=' + props.filter);
      }
      if (props.backdropFilter !== 'none') {
        isBreaker = true;
        breakerReasons.push('backdrop-filter=' + props.backdropFilter);
      }
      if (props.perspective !== 'none') {
        isBreaker = true;
        breakerReasons.push('perspective=' + props.perspective);
      }
      if (props.contain && props.contain !== 'none' && (props.contain.includes('paint') || props.contain.includes('layout') || props.contain.includes('strict'))) {
        isBreaker = true;
        breakerReasons.push('contain=' + props.contain);
      }
      if (props.willChange === 'transform') {
        isBreaker = true;
        breakerReasons.push('will-change=transform');
      }
      
      if (isBreaker) {
        console.log('      ⚠️  BREAKER:', breakerReasons.join(', '));
        ancestorBreakers.push({
          element: selector,
          level: i,
          reasons: breakerReasons
        });
        reasons.push('Ancestor breaker: ' + selector + ' (' + breakerReasons.join(', ') + ')');
      } else {
        console.log('      ✅ OK');
      }
    });
    console.log('');
    
    // Identify scroll container
    var scrollContainer = null;
    var scrollContainerType = 'viewport';
    current = stickyEl.parentElement;
    while (current && current !== document.body) {
      var computed = getComputedStyle(current);
      if (computed.overflowY === 'auto' || computed.overflowY === 'scroll' || computed.overflow === 'auto' || computed.overflow === 'scroll') {
        scrollContainer = current;
        scrollContainerType = 'nested (' + (current.className || current.tagName) + ')';
        break;
      }
      current = current.parentElement;
    }
    
    console.log('7. Scroll Container:');
    console.log('   Type:', scrollContainerType);
    if (scrollContainer) {
      console.log('   Element:', scrollContainer.className || scrollContainer.tagName);
    }
    console.log('');
    
    // Get sticky top value and actual top
    var stickyTop = stickyComputed.top;
    var stickyTopValue = parseFloat(stickyTop) || 0;
    var actualTop = stickyEl.getBoundingClientRect().top;
    
    // Get html/body overflow for scroll container check
    var htmlOverflowY = getComputedStyle(document.documentElement).overflowY;
    var bodyOverflowY = getComputedStyle(document.body).overflowY;
    
    // Runtime sticky behavior test
    console.log('8. Runtime Sticky Behavior Test:');
    var initialRect = stickyEl.getBoundingClientRect();
    var initialTop = initialRect.top;
    var initialScrollY = window.scrollY || window.pageYOffset;
    
    console.log('   Initial state:');
    console.log('     scrollY:', initialScrollY);
    console.log('     stickyEl.getBoundingClientRect().top:', initialTop.toFixed(2), 'px');
    console.log('     stickyEl computed top:', stickyComputed.top);
    
    // Scroll down and measure
    var testScrollAmount = 300;
    var originalScrollY = window.scrollY || window.pageYOffset;
    
    console.log('   Scrolling down', testScrollAmount, 'px...');
    window.scrollTo(0, originalScrollY + testScrollAmount);
    
    // Wait for scroll to complete
    setTimeout(function() {
      var afterRect = stickyEl.getBoundingClientRect();
      var afterTop = afterRect.top;
      var afterScrollY = window.scrollY || window.pageYOffset;
      var actualScroll = afterScrollY - originalScrollY;
      
      console.log('   After scroll:');
      console.log('     scrollY:', afterScrollY, '(scrolled', actualScroll.toFixed(2), 'px)');
      console.log('     stickyEl.getBoundingClientRect().top:', afterTop.toFixed(2), 'px');
      
      var topChanged = Math.abs(afterTop - initialTop) > 1; // Allow 1px tolerance
      var expectedTop = parseFloat(stickyComputed.top) || 80;
      var isSticky = !topChanged || (afterTop <= expectedTop + 5 && afterTop >= expectedTop - 5);
      
      console.log('   Analysis:');
      console.log('     Top changed:', topChanged ? 'YES (' + (afterTop - initialTop).toFixed(2) + 'px)' : 'NO (sticky ✅)');
      console.log('     Expected top:', expectedTop, 'px');
      console.log('     Actual top:', afterTop.toFixed(2), 'px');
      console.log('     Is sticky:', isSticky ? '✅ YES' : '❌ NO');
      
      if (!isSticky && actualScroll > 0) {
        reasons.push('Sticky behavior test failed: top changed by ' + (afterTop - initialTop).toFixed(2) + 'px after scroll');
      }
      
      // Restore scroll position
      window.scrollTo(0, originalScrollY);
      
      // Final verdict
      var allPass = isDesktop && 
                    stickyComputed.position === 'sticky' && 
                    stickyComputed.top !== 'auto' && 
                    stickyComputed.top !== '' && 
                    isDirectChild && 
                    isGrid && 
                    ancestorBreakers.length === 0 &&
                    (actualScroll === 0 || isSticky); // If we scrolled, sticky should work
      
      console.log('');
      console.log('9. FINAL VERDICT:', allPass ? '✅ PASS' : '❌ FAIL');
      if (!allPass) {
        console.log('   Failing reasons:');
        reasons.forEach(function(reason) {
          console.log('     -', reason);
        });
      }
      console.log('');
      console.log('=== END PROOF ===');
      
      // Get sticky top value and actual top
      var stickyTopValueFinal = parseFloat(stickyComputed.top) || 0;
      var actualTopNow = stickyEl.getBoundingClientRect().top;
      var htmlOverflowYFinal = getComputedStyle(document.documentElement).overflowY;
      var bodyOverflowYFinal = getComputedStyle(document.body).overflowY;
      
      // Return result with required format
      var finalResult = {
        pass: allPass,
        reasons: reasons,
        stickyTop: stickyTopValueFinal,
        actualTop: actualTopNow,
        htmlOverflowY: htmlOverflowYFinal,
        bodyOverflowY: bodyOverflowYFinal,
        selector: '.recovery-cream-hero__images',
        position: stickyComputed.position,
        isDirectChild: isDirectChild,
        isGrid: isGrid,
        ancestorBreakers: ancestorBreakers,
        scrollContainer: scrollContainerType,
        stickyTest: {
          initialTop: initialTop,
          afterTop: afterTop,
          isSticky: isSticky
        }
      };
      
      window.__RC_STICKY_PROOF_RESULT__ = finalResult;
      
      console.log('Result stored in: window.__RC_STICKY_PROOF_RESULT__');
    }, 100);
    
    // Return immediately (async test continues)
    var initialResult = {
      pass: false, // Will be updated by async test
      reasons: ['Running async scroll test...'],
      stickyTop: stickyTopValue,
      actualTop: actualTop,
      htmlOverflowY: htmlOverflowY,
      bodyOverflowY: bodyOverflowY,
      message: 'Scroll test in progress. Check console for full results. Final result in window.__RC_STICKY_PROOF_RESULT__'
    };
    
    // Store for async update
    window.__RC_STICKY_PROOF_RESULT__ = initialResult;
    
    return initialResult;
  };
  
  // PHASE B: Scroll Lock Debug Helper (concise)
  window.__VELUNA_SCROLL_DEBUG__ = function() {
    var h=document.documentElement,b=document.body,se=document.scrollingElement||h;
    var hasArrae=h.classList.contains('veluna-ux--arrae-drawer');
    var hasDrawer=b.classList.contains('cart-drawer-open')||b.classList.contains('drawer-open');
    var hOY=getComputedStyle(h).overflowY,bOY=getComputedStyle(b).overflowY,bPos=getComputedStyle(b).position;
    var iSY=window.scrollY||window.pageYOffset,iST=se.scrollTop;
    console.log('=== SCROLL DEBUG ===');
    console.log('html.veluna-ux--arrae-drawer:',hasArrae);
    console.log('body.cart-drawer-open:',hasDrawer);
    console.log('html overflow-y:',hOY,'body overflow-y:',bOY,'body position:',bPos);
    console.log('scrollTop:',iST);
    try{window.scrollBy(0,200);setTimeout(function(){var aSY=window.scrollY||window.pageYOffset,aST=se.scrollTop,chg=Math.abs(aSY-iSY)>1||Math.abs(aST-iST)>1;console.log('After scrollBy(0,200): scrollY',aSY,'scrollTop',aST,'changed',chg?'✅YES':'❌NO');window.scrollTo(0,iSY);console.log('VERDICT:',chg?'✅SCROLL WORKS':'❌SCROLL LOCKED');},50);}catch(e){console.log('Test failed:',e.message);}
    return{hasArrae:hasArrae,hasDrawer:hasDrawer,htmlOverflowY:hOY,bodyOverflowY:bOY,bodyPosition:bPos,scrollTop:iST};
  };
  
  // PATTERN B: Comprehensive Scroll Lock Proof Function (returns correct format)
  window.rcScrollLockProof = function() {
    var h=document.documentElement,b=document.body,d=document.querySelector('[data-cart-drawer]');
    var isOpen=d&&d.classList.contains('veluna-cart-drawer--open');
    var hC=Array.from(h.classList),bC=Array.from(b.classList);
    var hS=getComputedStyle(h),bS=getComputedStyle(b);
    var se=document.scrollingElement||h,st=se.scrollTop;
    var lock=['cart-drawer-open','drawer-open','veluna-drawer-open','overflow-hidden','no-scroll'];
    var hLock=hC.some(function(c){return lock.includes(c);});
    var bLock=bC.some(function(c){return lock.includes(c);});
    var iSY=window.scrollY||window.pageYOffset;
    console.log('=== SCROLL LOCK PROOF ===');
    console.log('Drawer open:',isOpen?'YES':'NO');
    console.log('HTML lock class:',hLock?'YES ('+hC.filter(function(c){return lock.includes(c);}).join(',')+')':'NO');
    console.log('Body lock class:',bLock?'YES ('+bC.filter(function(c){return lock.includes(c);}).join(',')+')':'NO');
    console.log('HTML overflow:',hS.overflow,'overflow-y:',hS.overflowY);
    console.log('Body overflow:',bS.overflow,'overflow-y:',bS.overflowY,'position:',bS.position);
    console.log('scrollTop:',st,'scrollY:',iSY);
    var canScroll=true;
    try{
      window.scrollBy(0,200);
      setTimeout(function(){
        var aSY=window.scrollY||window.pageYOffset,aST=se.scrollTop;
        var chg=Math.abs(aSY-iSY)>1||Math.abs(aST-st)>1;
        canScroll=chg;
        console.log('After scrollBy(0,200): scrollY',aSY,'scrollTop',aST,'changed',chg?'YES':'NO');
        window.scrollTo(0,iSY);
        console.log('VERDICT:',chg?'✅SCROLL WORKS':'❌SCROLL LOCKED');
        if(!chg){
          var r=[];
          if(bLock)r.push('Body lock class');
          if(hLock)r.push('HTML lock class');
          if(bS.position==='fixed')r.push('Body fixed');
          if(bS.overflowY==='hidden')r.push('Body overflow hidden');
          if(hS.overflowY==='hidden')r.push('HTML overflow hidden');
          console.log('Causes:',r.join(', '));
        }
        console.log('=== END PROOF ===');
      },50);
    }catch(e){
      console.log('Test failed:',e.message);
      canScroll=false;
    }
    var htmlClass=hC.filter(function(c){return lock.includes(c);}).join(',')||'none';
    var bodyClass=bC.filter(function(c){return lock.includes(c);}).join(',')||'none';
    return{
      drawerOpen:isOpen,
      htmlClass:htmlClass,
      bodyClass:bodyClass,
      htmlOverflow:hS.overflow,
      bodyOverflow:bS.overflow,
      htmlOverflowY:hS.overflowY,
      bodyOverflowY:bS.overflowY,
      canScroll:canScroll
    };
  };
  
  // PHASE C: Media Height Proof Function (computed styles + bounding rects)
  window.rcMediaHeightProof = function() {
    console.log('=== RECOVERY CREAM MEDIA HEIGHT PROOF ===\n');
    
    var result = {
      timestamp: new Date().toISOString(),
      viewport: {
        width: window.innerWidth,
        height: window.innerHeight,
        dvh: window.innerHeight, // Approximate dvh (browser support varies)
        isDesktop: window.innerWidth >= 990
      },
      stickyTop: getComputedStyle(document.documentElement).getPropertyValue('--rc-sticky-top') || '97px',
      elements: {}
    };
    
    // 1. Sticky media container
    var imagesContainer = document.querySelector('.recovery-cream-hero__images');
    if (imagesContainer) {
      var imagesComputed = getComputedStyle(imagesContainer);
      var imagesRect = imagesContainer.getBoundingClientRect();
      result.elements.imagesContainer = {
        selector: '.recovery-cream-hero__images',
        computed: {
          height: imagesComputed.height,
          maxHeight: imagesComputed.maxHeight,
          minHeight: imagesComputed.minHeight,
          display: imagesComputed.display,
          flexDirection: imagesComputed.flexDirection,
          position: imagesComputed.position,
          top: imagesComputed.top
        },
        boundingRect: {
          height: imagesRect.height,
          width: imagesRect.width,
          top: imagesRect.top,
          bottom: imagesRect.bottom
        }
      };
      console.log('1. .recovery-cream-hero__images:');
      console.log('   Computed height:', imagesComputed.height);
      console.log('   Computed max-height:', imagesComputed.maxHeight);
      console.log('   Computed min-height:', imagesComputed.minHeight);
      console.log('   Bounding rect height:', imagesRect.height.toFixed(2), 'px');
      console.log('');
    } else {
      result.elements.imagesContainer = { error: 'Element not found' };
      console.log('❌ .recovery-cream-hero__images not found');
    }
    
    // 2. Mosaic wrapper
    var imagesDesktop = document.querySelector('.recovery-cream-hero__images-desktop');
    if (imagesDesktop) {
      var desktopComputed = getComputedStyle(imagesDesktop);
      var desktopRect = imagesDesktop.getBoundingClientRect();
      result.elements.imagesDesktop = {
        selector: '.recovery-cream-hero__images-desktop',
        computed: {
          height: desktopComputed.height,
          maxHeight: desktopComputed.maxHeight,
          minHeight: desktopComputed.minHeight,
          display: desktopComputed.display,
          flexDirection: desktopComputed.flexDirection
        },
        boundingRect: {
          height: desktopRect.height,
          width: desktopRect.width
        }
      };
      console.log('2. .recovery-cream-hero__images-desktop:');
      console.log('   Computed height:', desktopComputed.height);
      console.log('   Computed min-height:', desktopComputed.minHeight);
      console.log('   Bounding rect height:', desktopRect.height.toFixed(2), 'px');
      console.log('');
    } else {
      result.elements.imagesDesktop = { error: 'Element not found' };
      console.log('❌ .recovery-cream-hero__images-desktop not found');
    }
    
    // 3. Single row (row "1")
    var singleRow = document.querySelector('.recovery-cream-hero__image-row--single');
    if (singleRow) {
      var singleComputed = getComputedStyle(singleRow);
      var singleRect = singleRow.getBoundingClientRect();
      result.elements.singleRow = {
        selector: '.recovery-cream-hero__image-row--single',
        computed: {
          flex: singleComputed.flex,
          flexGrow: singleComputed.flexGrow,
          flexShrink: singleComputed.flexShrink,
          flexBasis: singleComputed.flexBasis,
          height: singleComputed.height,
          minHeight: singleComputed.minHeight,
          display: singleComputed.display
        },
        boundingRect: {
          height: singleRect.height,
          width: singleRect.width
        }
      };
      console.log('3. .recovery-cream-hero__image-row--single:');
      console.log('   Computed flex:', singleComputed.flex);
      console.log('   Computed height:', singleComputed.height);
      console.log('   Bounding rect height:', singleRect.height.toFixed(2), 'px');
      console.log('');
    } else {
      result.elements.singleRow = { error: 'Element not found' };
      console.log('❌ .recovery-cream-hero__image-row--single not found');
    }
    
    // 4. Double rows (row "2" - two instances)
    var doubleRows = document.querySelectorAll('.recovery-cream-hero__image-row--double');
    result.elements.doubleRows = [];
    doubleRows.forEach(function(row, i) {
      var doubleComputed = getComputedStyle(row);
      var doubleRect = row.getBoundingClientRect();
      var rowData = {
        index: i + 1,
        selector: '.recovery-cream-hero__image-row--double',
        computed: {
          flex: doubleComputed.flex,
          flexGrow: doubleComputed.flexGrow,
          flexShrink: doubleComputed.flexShrink,
          flexBasis: doubleComputed.flexBasis,
          height: doubleComputed.height,
          minHeight: doubleComputed.minHeight,
          display: doubleComputed.display
        },
        boundingRect: {
          height: doubleRect.height,
          width: doubleRect.width
        }
      };
      result.elements.doubleRows.push(rowData);
      console.log('4.' + (i + 1) + '. .recovery-cream-hero__image-row--double (instance ' + (i + 1) + '):');
      console.log('   Computed flex:', doubleComputed.flex);
      console.log('   Computed height:', doubleComputed.height);
      console.log('   Bounding rect height:', doubleRect.height.toFixed(2), 'px');
    });
    if (doubleRows.length === 0) {
      console.log('❌ .recovery-cream-hero__image-row--double not found');
    }
    console.log('');
    
    // Calculate expected vs actual
    if (result.viewport.isDesktop && imagesContainer && imagesDesktop && singleRow && doubleRows.length >= 2) {
      var expectedHeight = parseFloat(result.stickyTop) || 97;
      var expectedContainerHeight = window.innerHeight - expectedHeight - 24;
      var actualContainerHeight = result.elements.imagesContainer.boundingRect.height;
      var heightMatch = Math.abs(actualContainerHeight - expectedContainerHeight) < 2; // 2px tolerance (as per requirements)
      
      var singleHeight = result.elements.singleRow.boundingRect.height;
      var doubleHeight1 = result.elements.doubleRows[0].boundingRect.height;
      var doubleHeight2 = result.elements.doubleRows[1] ? result.elements.doubleRows[1].boundingRect.height : 0;
      var ratioMatch = Math.abs(singleHeight - (doubleHeight1 * 2)) < 3; // 3px tolerance (as per requirements) - Single should be ~2x double
      
      result.verdict = {
        containerHeightMatch: heightMatch,
        expectedContainerHeight: expectedContainerHeight,
        actualContainerHeight: actualContainerHeight,
        ratioMatch: ratioMatch,
        singleHeight: singleHeight,
        doubleHeight1: doubleHeight1,
        doubleHeight2: doubleHeight2,
        pass: heightMatch && ratioMatch
      };
      
      console.log('5. VERDICT:');
      console.log('   Container height match:', heightMatch ? '✅ YES' : '❌ NO');
      console.log('   Expected:', expectedContainerHeight.toFixed(2), 'px');
      console.log('   Actual:', actualContainerHeight.toFixed(2), 'px');
      console.log('   Ratio match (single ≈ 2x double):', ratioMatch ? '✅ YES' : '❌ NO');
      console.log('   Single row height:', singleHeight.toFixed(2), 'px');
      console.log('   Double row 1 height:', doubleHeight1.toFixed(2), 'px');
      console.log('   Double row 2 height:', doubleHeight2.toFixed(2), 'px');
      console.log('   Overall:', result.verdict.pass ? '✅ PASS' : '❌ FAIL');
    } else {
      result.verdict = { pass: false, reason: 'Missing elements or not desktop' };
      console.log('❌ Cannot verify: missing elements or not desktop viewport');
    }
    
    console.log('');
    console.log('=== END PROOF ===');
    console.log('Result stored in: window.__RC_MEDIA_HEIGHT_PROOF_RESULT__');
    
    window.__RC_MEDIA_HEIGHT_PROOF_RESULT__ = result;
    return result;
  };
  
  // CANONICAL PROOF: Desktop Sticky Mosaic Determinism (>=990px)
  window.rcStickyMosaicProof = function() {
    console.log('=== RECOVERY CREAM STICKY MOSAIC PROOF (CANONICAL) ===\n');
    
    var result = {
      timestamp: new Date().toISOString(),
      viewport: {
        width: window.innerWidth,
        height: window.innerHeight,
        isDesktop: window.innerWidth >= 990,
        isTwoColumn: window.innerWidth >= 769
      },
      stickyTop: getComputedStyle(document.documentElement).getPropertyValue('--rc-sticky-top') || '97px',
      elements: {},
      inlineStyles: {},
      verdict: {}
    };
    
    // Helper: Check if desktop breakpoint (2-column grid activates at 769px)
    var isDesktop990 = window.matchMedia('(min-width: 990px)').matches;
    var isTwoColumn = window.matchMedia('(min-width: 769px)').matches; // 2-column grid breakpoint
    
    // 1. Outer wrapper
    var outer = document.querySelector('.recovery-cream-hero__images');
    if (outer) {
      var csOuter = getComputedStyle(outer);
      var rOuter = outer.getBoundingClientRect();
      var inlineOuter = outer.getAttribute('style') || '';
      
      result.elements.outer = {
        selector: '.recovery-cream-hero__images',
        computed: {
          position: csOuter.position,
          height: csOuter.height,
          minHeight: csOuter.minHeight,
          maxHeight: csOuter.maxHeight
        },
        boundingRect: {
          height: Math.round(rOuter.height)
        },
        inlineStyle: inlineOuter
      };
      
      console.log('1. OUTER WRAPPER (.recovery-cream-hero__images):');
      console.log('   Position:', csOuter.position);
      console.log('   Height:', csOuter.height);
      console.log('   Max-height:', csOuter.maxHeight);
      console.log('   Bounding rect height:', Math.round(rOuter.height), 'px');
      console.log('   Inline style:', inlineOuter || '(none)');
      console.log('');
    } else {
      result.elements.outer = { error: 'Element not found' };
      console.log('❌ .recovery-cream-hero__images not found');
    }
    
    // 2. Inner container
    var inner = document.querySelector('.recovery-cream-hero__images-desktop');
    if (inner) {
      var csInner = getComputedStyle(inner);
      var rInner = inner.getBoundingClientRect();
      var inlineInner = inner.getAttribute('style') || '';
      
      // Check for problematic inline styles
      var hasInline100vh = inlineInner.includes('100vh') || inlineInner.includes('100dvh');
      var hasInlineSpaceBetween = inlineInner.includes('space-between');
      
      result.elements.inner = {
        selector: '.recovery-cream-hero__images-desktop',
        computed: {
          position: csInner.position,
          top: csInner.top,
          height: csInner.height,
          minHeight: csInner.minHeight,
          maxHeight: csInner.maxHeight,
          justifyContent: csInner.justifyContent
        },
        boundingRect: {
          height: Math.round(rInner.height)
        },
        inlineStyle: inlineInner
      };
      
      result.inlineStyles = {
        innerHasInline100vh: hasInline100vh,
        innerHasInlineSpaceBetween: hasInlineSpaceBetween
      };
      
      console.log('2. INNER CONTAINER (.recovery-cream-hero__images-desktop):');
      console.log('   Position:', csInner.position);
      console.log('   Top:', csInner.top);
      console.log('   Height:', csInner.height);
      console.log('   Justify-content:', csInner.justifyContent);
      console.log('   Bounding rect height:', Math.round(rInner.height), 'px');
      console.log('   Inline style:', inlineInner || '(none)');
      console.log('   ⚠️  Has inline 100vh:', hasInline100vh ? 'YES ❌' : 'NO ✅');
      console.log('   ⚠️  Has inline space-between:', hasInlineSpaceBetween ? 'YES ❌' : 'NO ✅');
      console.log('');
    } else {
      result.elements.inner = { error: 'Element not found' };
      console.log('❌ .recovery-cream-hero__images-desktop not found');
    }
    
    // 3. Verdict (2-column grid only, >=769px)
    if (isTwoColumn && outer && inner) {
      var outerOk = result.elements.outer.computed.position === 'static' &&
                     result.elements.outer.computed.height === 'auto' &&
                     result.elements.outer.computed.maxHeight === 'none';
      
      var innerOk = result.elements.inner.computed.position === 'sticky' &&
                    result.elements.inner.computed.top !== 'auto' &&
                    parseFloat(result.elements.inner.computed.top) >= 0;
      
      var justifyOk = result.elements.inner.computed.justifyContent === 'flex-start';
      
      var inlineOk = !result.inlineStyles.innerHasInline100vh &&
                     !result.inlineStyles.innerHasInlineSpaceBetween;
      
      // Height match check - sticky container should match outer wrapper height (which matches container height driven by right column)
      var outerRect = outer ? outer.getBoundingClientRect() : null;
      var outerHeight = outerRect ? outerRect.height : 0;
      var actualContainerHeight = result.elements.inner.boundingRect.height;
      // Sticky container height should match outer wrapper height (within 2px tolerance for rounding)
      var heightMatch = outerHeight > 0 && Math.abs(actualContainerHeight - outerHeight) < 2;
      
      // Mosaic fills left column check - should fill full outer wrapper height
      var mosaicFillsLeftColumn = false;
      var mosaicCheck = null;
      var mosaicContainer = inner; // The sticky container IS the mosaic container
      
      if (isTwoColumn && mosaicContainer && outerHeight > 0) {
        var mosaicRect = mosaicContainer.getBoundingClientRect();
        var mosaicHeight = mosaicRect.height;
        var expectedMosaicHeight = outerHeight; // Should match outer wrapper height (which equals container height)
        var minMosaicHeight = expectedMosaicHeight * 0.92; // 92% tolerance (accounts for rounding/gaps)
        
        // Mosaic should fill at least 92% of outer wrapper height
        mosaicFillsLeftColumn = mosaicHeight >= minMosaicHeight;
        
        mosaicCheck = {
          expectedHeight: expectedMosaicHeight,
          mosaicHeight: mosaicHeight,
          minRequiredHeight: minMosaicHeight,
          ratio: (mosaicHeight / expectedMosaicHeight) * 100,
          pass: mosaicFillsLeftColumn
        };
        
        result.mosaicCheck = mosaicCheck;
      }
      
      // Sticky persists mid-hero check
      var stickyPersistsMidHero = false;
      var container = document.querySelector('.recovery-cream-hero__container');
      var stickyMidHeroCheck = null;
      
      if (isTwoColumn && container && inner) {
        var containerRect = container.getBoundingClientRect();
        var containerTop = containerRect.top + window.scrollY; // Absolute position
        var containerHeight = containerRect.height;
        
        // Calculate scroll target: 60% through the hero (mid-hero, still within container)
        var scrollTarget = containerTop + (containerHeight * 0.6);
        
        // Store current scroll position
        var originalScrollY = window.scrollY;
        
        // Scroll to mid-hero synchronously (using scrollTo with instant behavior)
        window.scrollTo(0, scrollTarget);
        
        // Force synchronous layout recalculation
        // Accessing offsetHeight forces a synchronous layout
        var _ = container.offsetHeight;
        var _2 = inner.offsetHeight;
        
        // Get sticky element position after scroll
        var innerRect = inner.getBoundingClientRect();
        var stickyTopValue = parseFloat(result.stickyTop) || 97;
        var expectedStickyTop = stickyTopValue;
        var actualStickyTop = innerRect.top;
        
        // Verify sticky element is still at sticky top position (within 3px tolerance)
        stickyPersistsMidHero = Math.abs(actualStickyTop - expectedStickyTop) < 3;
        
        stickyMidHeroCheck = {
          containerHeight: containerHeight,
          scrollTarget: scrollTarget,
          expectedStickyTop: expectedStickyTop,
          actualStickyTop: actualStickyTop,
          difference: Math.abs(actualStickyTop - expectedStickyTop),
          pass: stickyPersistsMidHero
        };
        
      // Restore original scroll position
      window.scrollTo(0, originalScrollY);
      
      // Force another layout recalculation
      var _3 = container.offsetHeight;
    }
    
    // Arrae-like structure: FAQs and cross-sell must be INSIDE the right column
    var faqsAreInRightColumn = false;
    var crossSellIsInRightColumn = false;
    var rightColumnCheck = {
      togglesFound: false,
      crossSellFound: false,
      togglesInRightColumn: null,
      crossSellInRightColumn: null,
      rightColumnFound: false,
      togglesLeftOffset: null,
      crossSellLeftOffset: null,
      pass: false
    };
    
    if (isTwoColumn && container) {
      var toggles = document.querySelector('.recovery-cream-hero__toggles');
      var crossSell = document.querySelector('.recovery-cream-hero__cross-sell');
      var rightColumn = document.querySelector('.recovery-cream-hero__info');
      
      rightColumnCheck.togglesFound = !!toggles;
      rightColumnCheck.crossSellFound = !!crossSell;
      rightColumnCheck.rightColumnFound = !!rightColumn;
      
      if (rightColumn) {
        var rightColumnRect = rightColumn.getBoundingClientRect();
        var rightColumnLeft = rightColumnRect.left;
        
        // Check FAQs are inside right column
        if (toggles) {
          var togglesInRight = rightColumn.contains(toggles);
          var togglesRect = toggles.getBoundingClientRect();
          var togglesLeftOffset = togglesRect.left - rightColumnLeft;
          
          // Toggles should be inside right column AND left edge should align with right column (within 20px tolerance)
          faqsAreInRightColumn = togglesInRight && Math.abs(togglesLeftOffset) < 20;
          
          rightColumnCheck.togglesInRightColumn = togglesInRight;
          rightColumnCheck.togglesLeftOffset = togglesLeftOffset;
        }
        
        // Check cross-sell is inside right column
        if (crossSell) {
          var crossSellInRight = rightColumn.contains(crossSell);
          var crossSellRect = crossSell.getBoundingClientRect();
          var crossSellLeftOffset = crossSellRect.left - rightColumnLeft;
          
          // Cross-sell should be inside right column AND left edge should align with right column (within 20px tolerance)
          crossSellIsInRightColumn = crossSellInRight && Math.abs(crossSellLeftOffset) < 20;
          
          rightColumnCheck.crossSellInRightColumn = crossSellInRight;
          rightColumnCheck.crossSellLeftOffset = crossSellLeftOffset;
        }
        
        // Both must be in right column (or at least one if only one exists)
        rightColumnCheck.pass = (faqsAreInRightColumn && (crossSell ? crossSellIsInRightColumn : true)) ||
                                (crossSellIsInRightColumn && (toggles ? faqsAreInRightColumn : true));
      }
    }
    
    result.rightColumnCheck = rightColumnCheck;
    
    result.verdict = {
      outerOk: outerOk,
      innerOk: innerOk,
      justifyOk: justifyOk,
      inlineOk: inlineOk,
      heightMatch: heightMatch,
      outerHeight: outerHeight > 0 ? outerHeight : null,
      actualContainerHeight: actualContainerHeight,
      stickyPersistsMidHero: stickyPersistsMidHero,
      mosaicFillsLeftColumn: mosaicFillsLeftColumn,
      faqsAreInRightColumn: faqsAreInRightColumn,
      crossSellIsInRightColumn: crossSellIsInRightColumn,
      pass: outerOk && innerOk && justifyOk && inlineOk && heightMatch && stickyPersistsMidHero && mosaicFillsLeftColumn && faqsAreInRightColumn && crossSellIsInRightColumn
    };
    
    if (stickyMidHeroCheck) {
      result.stickyMidHeroCheck = stickyMidHeroCheck;
    }
      
      console.log('3. VERDICT (Desktop >=990px):');
      console.log('   Outer OK (static, auto, none):', outerOk ? '✅ YES' : '❌ NO');
      console.log('   Inner OK (sticky, top not auto):', innerOk ? '✅ YES' : '❌ NO');
      console.log('   Justify OK (flex-start):', justifyOk ? '✅ YES' : '❌ NO');
      console.log('   Inline OK (no 100vh, no space-between):', inlineOk ? '✅ YES' : '❌ NO');
      console.log('   Height match (within 2px):', heightMatch ? '✅ YES' : '❌ NO');
      if (outerHeight > 0) {
        console.log('   Outer wrapper height:', outerHeight.toFixed(2), 'px');
        console.log('   Sticky container height:', actualContainerHeight.toFixed(2), 'px');
      }
      console.log('   Sticky persists mid-hero:', result.verdict.stickyPersistsMidHero ? '✅ YES' : '❌ NO');
      console.log('   Mosaic fills left column:', result.verdict.mosaicFillsLeftColumn ? '✅ YES' : '❌ NO');
      if (result.mosaicCheck) {
        console.log('   Mosaic check - Expected:', result.mosaicCheck.expectedHeight.toFixed(2), 'px');
        console.log('   Mosaic check - Actual:', result.mosaicCheck.mosaicHeight.toFixed(2), 'px');
        console.log('   Mosaic check - Ratio:', result.mosaicCheck.ratio.toFixed(1), '%');
        console.log('   Mosaic check - Min required:', result.mosaicCheck.minRequiredHeight.toFixed(2), 'px');
      }
      if (result.stickyMidHeroCheck) {
        console.log('   Mid-hero check - Expected top:', result.stickyMidHeroCheck.expectedStickyTop.toFixed(2), 'px');
        console.log('   Mid-hero check - Actual top:', result.stickyMidHeroCheck.actualStickyTop.toFixed(2), 'px');
        console.log('   Mid-hero check - Difference:', result.stickyMidHeroCheck.difference.toFixed(2), 'px');
      }
      console.log('   FAQs in right column:', result.verdict.faqsAreInRightColumn ? '✅ YES' : '❌ NO');
      console.log('   Cross-sell in right column:', result.verdict.crossSellIsInRightColumn ? '✅ YES' : '❌ NO');
      if (result.rightColumnCheck) {
        if (result.rightColumnCheck.togglesFound) {
          console.log('   FAQs found:', '✅ YES');
          console.log('   FAQs in right column:', result.rightColumnCheck.togglesInRightColumn ? '✅ YES' : '❌ NO');
          if (result.rightColumnCheck.togglesLeftOffset !== null) {
            console.log('   FAQs left offset:', result.rightColumnCheck.togglesLeftOffset.toFixed(2), 'px');
          }
        }
        if (result.rightColumnCheck.crossSellFound) {
          console.log('   Cross-sell found:', '✅ YES');
          console.log('   Cross-sell in right column:', result.rightColumnCheck.crossSellInRightColumn ? '✅ YES' : '❌ NO');
          if (result.rightColumnCheck.crossSellLeftOffset !== null) {
            console.log('   Cross-sell left offset:', result.rightColumnCheck.crossSellLeftOffset.toFixed(2), 'px');
          }
        }
      }
      console.log('   Overall:', result.verdict.pass ? '✅ PASS' : '❌ FAIL');
    } else {
      result.verdict = {
        pass: false,
        reason: isTwoColumn ? 'Missing elements' : 'Not 2-column viewport (width < 769px)'
      };
      console.log('❌ Cannot verify:', result.verdict.reason);
    }
    
    console.log('');
    console.log('=== END PROOF ===');
    console.log('Result stored in: window.__RC_STICKY_MOSAIC_PROOF_RESULT__');
    
    window.__RC_STICKY_MOSAIC_PROOF_RESULT__ = result;
    return result;
  };
  
  // MUTATION WATCHER: Detect inline style changes at desktop (>=990px)
  window.rcWatchInlineStyles = function(options) {
    options = options || {};
    var durationMs = options.durationMs || 3000;
    var targetSelector = options.targetSelector || '.recovery-cream-hero__images-desktop';
    
    console.log('=== RECOVERY CREAM INLINE STYLE WATCHER ===\n');
    console.log('Watching:', targetSelector);
    console.log('Duration:', durationMs, 'ms');
    console.log('Current viewport:', window.innerWidth, 'px', window.innerWidth >= 990 ? '(Desktop >=990px)' : '(Tablet/Mobile <990px)');
    console.log('');
    
    var target = document.querySelector(targetSelector);
    if (!target) {
      console.log('❌ Target element not found:', targetSelector);
      return { error: 'Target not found', mutations: [] };
    }
    
    var isDesktop990 = window.matchMedia('(min-width: 990px)').matches;
    var initialStyle = target.getAttribute('style') || '';
    var mutations = [];
    var startTime = Date.now();
    
    // Watch for style attribute changes
    var observer = new MutationObserver(function(mutationsList) {
      mutationsList.forEach(function(mutation) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'style') {
          var newStyle = target.getAttribute('style') || '';
          var has100vh = newStyle.includes('100vh') || newStyle.includes('100dvh');
          var hasSpaceBetween = newStyle.includes('space-between');
          
          // Only flag if at desktop (>=990px)
          if (isDesktop990 && (has100vh || hasSpaceBetween)) {
            mutations.push({
              timestamp: Date.now() - startTime,
              newStyle: newStyle,
              has100vh: has100vh,
              hasSpaceBetween: hasSpaceBetween,
              isDesktop: isDesktop990
            });
            
            console.log('⚠️  INLINE STYLE DETECTED at desktop (>=990px):');
            console.log('   Time:', (Date.now() - startTime), 'ms');
            console.log('   Has 100vh:', has100vh ? 'YES ❌' : 'NO ✅');
            console.log('   Has space-between:', hasSpaceBetween ? 'YES ❌' : 'NO ✅');
            console.log('   Style:', newStyle.substring(0, 100) + (newStyle.length > 100 ? '...' : ''));
            console.log('');
          }
        }
      });
    });
    
    observer.observe(target, {
      attributes: true,
      attributeFilter: ['style']
    });
    
    console.log('Watching for inline style changes...');
    console.log('Initial style:', initialStyle || '(none)');
    console.log('');
    
    // Stop after duration
    setTimeout(function() {
      observer.disconnect();
      
      var result = {
        target: targetSelector,
        isDesktop: isDesktop990,
        durationMs: durationMs,
        initialStyle: initialStyle,
        finalStyle: target.getAttribute('style') || '',
        mutations: mutations,
        hasViolations: mutations.length > 0,
        pass: mutations.length === 0
      };
      
      console.log('=== WATCHER RESULTS ===');
      console.log('Mutations detected:', mutations.length);
      if (mutations.length === 0) {
        console.log('✅ PASS: No inline styles applied at desktop (>=990px)');
      } else {
        console.log('❌ FAIL: Inline styles detected at desktop (>=990px)');
        console.log('Violations:', mutations.length);
      }
      console.log('Final style:', result.finalStyle || '(none)');
      console.log('');
      console.log('=== END WATCHER ===');
      
      window.__RC_INLINE_STYLE_WATCH_RESULT__ = result;
      return result;
    }, durationMs);
    
    // Return immediately (async watcher continues)
    return {
      target: targetSelector,
      isDesktop: isDesktop990,
      durationMs: durationMs,
      watching: true,
      message: 'Watcher active. Check console for results after ' + durationMs + 'ms. Final result in window.__RC_INLINE_STYLE_WATCH_RESULT__'
    };
  };
  
  // DOM SCAN: Find "Translation missing:" strings
  window.rcScanTranslationMissing = function() {
    console.log('=== RECOVERY CREAM TRANSLATION SCAN ===\n');
    
    var results = {
      timestamp: new Date().toISOString(),
      found: [],
      count: 0
    };
    
    // Scan all text nodes
    var walker = document.createTreeWalker(
      document.body,
      NodeFilter.SHOW_TEXT,
      null,
      false
    );
    
    var node;
    while (node = walker.nextNode()) {
      var text = node.textContent || '';
      if (text.includes('Translation missing:') || text.includes('translation missing:')) {
        var parent = node.parentElement;
        var selector = parent ? (parent.className ? '.' + parent.className.split(' ')[0] : parent.tagName.toLowerCase()) : 'unknown';
        
        results.found.push({
          text: text.trim().substring(0, 100),
          selector: selector,
          parentTag: parent ? parent.tagName.toLowerCase() : 'unknown'
        });
        results.count++;
      }
    }
    
    // Also scan for skip-to-content link specifically
    var skipLink = document.querySelector('.skip-to-content, a[href="#MainContent"]');
    if (skipLink) {
      var skipText = skipLink.textContent || '';
      var hasTranslationMissing = skipText.includes('Translation missing:');
      results.skipLink = {
        found: true,
        text: skipText,
        hasTranslationMissing: hasTranslationMissing
      };
    } else {
      results.skipLink = { found: false };
    }
    
    console.log('Translation missing strings found:', results.count);
    if (results.count === 0) {
      console.log('✅ PASS: No "Translation missing:" strings found');
    } else {
      console.log('❌ FAIL: Found', results.count, '"Translation missing:" string(s)');
      results.found.forEach(function(item, i) {
        console.log('  ' + (i + 1) + '.', item.text.substring(0, 80) + '...');
        console.log('     Selector:', item.selector);
      });
    }
    console.log('');
    console.log('Skip link:', results.skipLink.found ? 'Found' : 'Not found');
    if (results.skipLink.found) {
      console.log('Skip link text:', results.skipLink.text);
      console.log('Has translation missing:', results.skipLink.hasTranslationMissing ? 'YES ❌' : 'NO ✅');
    }
    console.log('');
    console.log('=== END SCAN ===');
    
    window.__RC_TRANSLATION_SCAN_RESULT__ = results;
    return results;
  };
  
  // CRITICAL DIAGNOSTIC: Troubleshoot blank runway issue
  // CRITICAL: Protect function from being overwritten
  // But allow wrapper to be replaced if it exists
  var rcTroubleshootBlankRunwayFn = function() {
    console.log('=== RECOVERY CREAM BLANK RUNWAY TROUBLESHOOTING ===\n');
    
    var container = document.querySelector('.recovery-cream-hero__container');
    var imagesContainer = document.querySelector('.recovery-cream-hero__images');
    var imagesDesktop = document.querySelector('.recovery-cream-hero__images-desktop');
    var infoSection = document.querySelector('.recovery-cream-hero__info');
    
    if (!container || !imagesContainer || !imagesDesktop || !infoSection) {
      console.log('❌ Missing elements:', {
        container: !!container,
        imagesContainer: !!imagesContainer,
        imagesDesktop: !!imagesDesktop,
        infoSection: !!infoSection
      });
      return;
    }
    
    var csContainer = getComputedStyle(container);
    var csImages = getComputedStyle(imagesContainer);
    var csImagesDesktop = getComputedStyle(imagesDesktop);
    var csInfo = getComputedStyle(infoSection);
    
    var rectContainer = container.getBoundingClientRect();
    var rectImages = imagesContainer.getBoundingClientRect();
    var rectImagesDesktop = imagesDesktop.getBoundingClientRect();
    var rectInfo = infoSection.getBoundingClientRect();
    
    console.log('1. GRID CONTAINER:');
    console.log('   Display:', csContainer.display);
    console.log('   Align-items:', csContainer.alignItems);
    console.log('   Height:', csContainer.height);
    console.log('   Bounding rect height:', Math.round(rectContainer.height), 'px');
    console.log('');
    
    console.log('2. LEFT COLUMN WRAPPER (.recovery-cream-hero__images):');
    console.log('   Position:', csImages.position);
    console.log('   Display:', csImages.display);
    console.log('   Flex-direction:', csImages.flexDirection);
    console.log('   Align-self:', csImages.alignSelf);
    console.log('   Height:', csImages.height);
    console.log('   Min-height:', csImages.minHeight);
    console.log('   Max-height:', csImages.maxHeight);
    console.log('   Bounding rect height:', Math.round(rectImages.height), 'px');
    console.log('   Inline style:', imagesContainer.getAttribute('style') || '(none)');
    console.log('');
    
    console.log('3. STICKY CONTAINER (.recovery-cream-hero__images-desktop):');
    console.log('   Position:', csImagesDesktop.position);
    console.log('   Top:', csImagesDesktop.top);
    console.log('   Display:', csImagesDesktop.display);
    console.log('   Flex:', csImagesDesktop.flex);
    console.log('   Height:', csImagesDesktop.height);
    console.log('   Min-height:', csImagesDesktop.minHeight);
    console.log('   Max-height:', csImagesDesktop.maxHeight);
    console.log('   Justify-content:', csImagesDesktop.justifyContent);
    console.log('   Bounding rect height:', Math.round(rectImagesDesktop.height), 'px');
    console.log('   Inline style:', imagesDesktop.getAttribute('style') || '(none)');
    console.log('');
    
    console.log('4. RIGHT COLUMN (.recovery-cream-hero__info):');
    console.log('   Height:', csInfo.height);
    console.log('   Bounding rect height:', Math.round(rectInfo.height), 'px');
    console.log('');
    
    console.log('5. HEIGHT COMPARISON:');
    var leftHeight = Math.round(rectImages.height);
    var rightHeight = Math.round(rectInfo.height);
    var stickyHeight = Math.round(rectImagesDesktop.height);
    console.log('   Left column height:', leftHeight, 'px');
    console.log('   Right column height:', rightHeight, 'px');
    console.log('   Sticky container height:', stickyHeight, 'px');
    console.log('   Height difference:', Math.abs(leftHeight - rightHeight), 'px');
    console.log('   Left matches right?', Math.abs(leftHeight - rightHeight) < 5 ? '✅ YES' : '❌ NO');
    console.log('   Sticky fills left?', Math.abs(stickyHeight - leftHeight) < 5 ? '✅ YES' : '❌ NO');
    console.log('');
    
    console.log('6. INLINE STYLE CHECK:');
    var imagesInline = imagesContainer.getAttribute('style') || '';
    var desktopInline = imagesDesktop.getAttribute('style') || '';
    var hasProblematicInline = false;
    
    if (imagesInline.includes('100vh') || imagesInline.includes('100dvh')) {
      console.log('   ❌ .recovery-cream-hero__images has 100vh in inline style!');
      hasProblematicInline = true;
    }
    if (desktopInline.includes('100vh') || desktopInline.includes('100dvh')) {
      console.log('   ❌ .recovery-cream-hero__images-desktop has 100vh in inline style!');
      hasProblematicInline = true;
    }
    if (desktopInline.includes('space-between')) {
      console.log('   ❌ .recovery-cream-hero__images-desktop has space-between in inline style!');
      hasProblematicInline = true;
    }
    if (!hasProblematicInline) {
      console.log('   ✅ No problematic inline styles found');
    }
    console.log('');
    
    console.log('7. VIEWPORT:');
    console.log('   Width:', window.innerWidth, 'px');
    console.log('   Is desktop (>=769px)?', window.innerWidth >= 769 ? '✅ YES' : '❌ NO');
    console.log('');
    
    var verdict = {
      gridStretching: csContainer.alignItems === 'stretch',
      leftStretches: Math.abs(leftHeight - rightHeight) < 5,
      stickyFills: Math.abs(stickyHeight - leftHeight) < 5,
      noProblematicInline: !hasProblematicInline,
      isDesktop: window.innerWidth >= 769
    };
    
    verdict.pass = verdict.gridStretching && verdict.leftStretches && verdict.stickyFills && verdict.noProblematicInline && verdict.isDesktop;
    
    console.log('8. VERDICT:');
    console.log('   Grid stretching enabled:', verdict.gridStretching ? '✅' : '❌');
    console.log('   Left matches right height:', verdict.leftStretches ? '✅' : '❌');
    console.log('   Sticky fills left column:', verdict.stickyFills ? '✅' : '❌');
    console.log('   No problematic inline styles:', verdict.noProblematicInline ? '✅' : '❌');
    console.log('   Is desktop viewport:', verdict.isDesktop ? '✅' : '❌');
    console.log('');
    console.log('   OVERALL:', verdict.pass ? '✅ PASS' : '❌ FAIL');
    console.log('');
    
    return verdict;
  };
  
  // Assign with protection, but allow overwriting wrapper
  // Always use simple assignment to ensure function is callable in all contexts
  try {
    var existing = window.rcTroubleshootBlankRunway;
    // If wrapper exists (has __RC_WRAPPER__ marker), replace it
    if(existing && existing.__RC_WRAPPER__) {
      window.rcTroubleshootBlankRunway = rcTroubleshootBlankRunwayFn;
      console.log('[RC PROOF] Replaced wrapper with full function');
    } else {
      // No wrapper, assign directly
      window.rcTroubleshootBlankRunway = rcTroubleshootBlankRunwayFn;
    }
  } catch(e) {
    window.rcTroubleshootBlankRunway = rcTroubleshootBlankRunwayFn;
  }
  
  // Also assign to top window if in iframe (for Theme Editor console)
  try {
    if(window.top !== window.self) {
      window.top.rcTroubleshootBlankRunway = rcTroubleshootBlankRunwayFn;
      console.log('[RC PROOF] Also assigned to top window');
    }
  } catch(e) {
    // Cross-origin, ignore
    console.log('[RC PROOF] Cannot assign to top window (cross-origin)');
  }
  
  console.log('[RC PROOF] ✅ window.rcStickyProof() defined');
  console.log('[RC PROOF] ✅ window.rcScrollLockProof() defined');
  console.log('[RC PROOF] ✅ window.__VELUNA_SCROLL_DEBUG__() defined');
  console.log('[RC PROOF] ✅ window.rcMediaHeightProof() defined');
  console.log('[RC PROOF] ✅ window.rcStickyMosaicProof() defined (CANONICAL)');
  console.log('[RC PROOF] ✅ window.rcWatchInlineStyles() defined');
  console.log('[RC PROOF] ✅ window.rcScanTranslationMissing() defined');
  console.log('[RC PROOF] ✅ window.rcTroubleshootBlankRunway() defined (protected)');
  console.log('[RC PROOF] Function type check:', typeof window.rcTroubleshootBlankRunway === 'function' ? '✅ function' : '❌ ' + typeof window.rcTroubleshootBlankRunway);
})();
